/** How many names fit under the confirmation before the rest collapse to "and N more". */
export const UPLOAD_PROGRESS_NAME_LIMIT = 3;

export type AnimatedOnboardingUploadProgress = {
  heading: string;
  moreLabel: string | undefined;
  names: readonly string[];
};

/** What the upload step says once files are picked, so leaving the screen is not the only sign. */
export const getAnimatedOnboardingUploadProgress = (fileNames: readonly string[]): AnimatedOnboardingUploadProgress => {
  const fileCount = fileNames.length;
  const names = fileNames.slice(0, UPLOAD_PROGRESS_NAME_LIMIT);
  const remainingCount = fileCount - names.length;

  return {
    heading: `Uploading ${fileCount} ${fileCount === 1 ? 'file' : 'files'}`,
    moreLabel: remainingCount > 0 ? `and ${remainingCount} more` : undefined,
    names,
  };
};
